export default {
  id: 208,
  title: 'Target #208 - Hulk fist',
  url: 'https://cssbattle.dev/play/208',
  colors: ['#107640', '#161D1A'],
  solution:
    '<p a><p b><p c><p d><p e><p f><p g><style>p[b],p[c],p[d],p[e]{width:22;background:#107640}p[a],p[b],p[c],p[d],p[e],p[f]{background:#107640}body{background:radial-gradient(circle,#161d1a 115px,#107640 115px)}p{position:fixed;margin:0}p[a]{top:161;left:132;width:130;height:110}p[b]{top:123;left:132;height:31}p[c]{top:103;left:168;height:51}p[d]{top:98;left:204;height:46}p[e]{top:103;left:240;height:41}p[f]{top:144;left:179;width:100;height:56;box-shadow:inset 0 0 0 7px #161d1a',
}
